<div class="calc-units">

  <h4 style="margin-bottom:0">{{(lineItem.finishedProduct && lineItem.finishedProduct.calcName) || '&nbsp;'}}</h4>

  <table style="margin: 0 auto">

    <tr><td>
      <ul *ngIf="dm.isEnergy" class="info">
        <li>
          <table class="infotable">
            <tr><th>Basic data</th><th>Value</th><th>Unit</th></tr>
            <tr><td>Area weight in kg</td><td>{{dm.metrics.areaWeight / 1000 | number:'1.4-4'}}</td><td>kg</td></tr>
            <tr><td>Tape width</td><td>{{dm.metrics.rollWidth | number:'1.4-4'}}</td><td>mm</td></tr>
            <tr><td>Tape length / sheet length</td><td>{{dm.metrics.rollLength | number:'1.4-4'}}</td><td>m</td></tr>
          </table>
        </li>
        <li>
          <table class="infotable">
            <tr><th>Basic units</th><th>Value</th><th>Unit</th></tr>
            <tr><td>1m²=</td><td>{{dm.basicUnits.qm | number:'1.4-4'}}</td><td>m²</td></tr>
            <tr><td>1m²=</td><td>{{dm.basicUnits.qmlm | number:'1.4-4'}}</td><td>lm</td></tr>
            <tr><td>1m²=</td><td>{{dm.basicUnits.qmkg | number:'1.4-4'}}</td><td>kg</td></tr>
          </table>
        </li>
        <li>
          <table class="infotable">
            <tr><th>Roll dimensions</th><th>Value</th><th>Unit</th></tr>
            <tr><td>m² of one roll</td><td>{{dm.rollDimensions.m2roll | number:'1.4-4'}}</td><td>m²</td></tr>
            <tr><td>lm of one roll</td><td>{{dm.rollDimensions.lmroll | number:'1.4-4'}}</td><td>lm</td></tr>
            <tr><td>kg of one roll</td><td>{{dm.rollDimensions.kgroll | number:'1.4-4'}}</td><td>kg</td></tr>
            <tr *ngIf="dm.rollDimensions.outerDiameter"><td>outer diameter</td><td>{{dm.rollDimensions.outerDiameter | number:'1.4-4'}}</td><td>mm</td></tr>
          </table>
        </li>
      </ul>

    </td><td rowspan="3" *ngIf="dm.isEnergy" style="padding-right: 1.5rem">

      <table class="infotable-boxes" style="position:relative;top:17px;">
        <tr *ngIf="dm.boxInfo.fpd?.length"><td>FPD</td><td *ngFor="let fpd of dm.boxInfo.fpd">{{fpd}}</td></tr>
        <tr *ngIf="!dm.boxInfo.fpd?.length"><td colspan="100">No FPD</td></tr>
        <tr><td>Box type</td><td *ngFor="let type of dm.boxInfo.type">{{type}}</td></tr>
        <tr><td>Rolls/box</td><td *ngFor="let rollsPerBox of dm.boxInfo.rollsPerBox">{{rollsPerBox}}</td></tr>
        <tr><td>Status</td><td *ngFor="let status of dm.boxInfo.status">{{status}}</td></tr>
        <tr><td># boxes</td><td *ngFor="let numBoxes of dm.boxInfo.numBoxes">{{numBoxes}}</td></tr>
        <tr><td>Full box &#11014;</td><td *ngFor="let fullUp of dm.boxInfo.fullUp; index as idx">{{fullUp}} pc
          <ng-container *ngIf="dm.calcValues.quantityUnit > 1"><br>{{dm.boxInfo.fullUpUnit[idx]}} {{unitData.get(+dm.calcValues.quantityUnit)?.short}}</ng-container></td></tr>
        <tr><td>Full box &#11015;</td><td *ngFor="let fullDown of dm.boxInfo.fullDown; index as idx">{{fullDown}} pc
          <ng-container *ngIf="dm.calcValues.quantityUnit > 1"><br>{{dm.boxInfo.fullDownUnit[idx]}} {{unitData.get(+dm.calcValues.quantityUnit)?.short}}</ng-container></td></tr>
        <tr *ngIf="dm.boxInfo.fpd?.length"><td>Max boxes / pallet</td><td *ngFor="let maxBoxes of dm.boxInfo.maxBoxes">{{maxBoxes}}</td></tr>
        <tr *ngIf="dm.boxInfo.fpd?.length"><td># pallets</td><td *ngFor="let numPallets of dm.boxInfo.numPallets">{{numPallets}}</td></tr>
        <tr *ngIf="dm.boxInfo.fpd?.length"><td>PalletStatus</td><td *ngFor="let status of dm.boxInfo.palletStatus">{{status}}</td></tr>
        <tr *ngIf="dm.boxInfo.fpd?.length"><td>Full pallet &#11014;</td><td *ngFor="let fullUp of dm.boxInfo.fullPalletUp; index as idx">{{fullUp}} pc
          <ng-container *ngIf="dm.calcValues.quantityUnit > 1"><br>{{dm.boxInfo.fullPalletUpUnit[idx]}} {{unitData.get(+dm.calcValues.quantityUnit)?.short}}</ng-container></td></tr>
        <tr *ngIf="dm.boxInfo.fpd?.length"><td>Full pallet &#11015;</td><td *ngFor="let fullDown of dm.boxInfo.fullPalletDown; index as idx">{{fullDown}} pc
          <ng-container *ngIf="dm.calcValues.quantityUnit > 1"><br>{{dm.boxInfo.fullPalletDownUnit[idx]}} {{unitData.get(+dm.calcValues.quantityUnit)?.short}}</ng-container></td></tr>
      </table>

    </td></tr>

    <tr><td style="position:relative;height:0;top:-1rem;left:2rem;text-align:left">
      <div>
        <span>Attached Price Files</span>
        <button class="nrk-button ml-2" [nbPopover]="uploadRef">
          <!-- <div><b>{{dm.fullMatrix?.files?.length ?? ''}}</b></div> -->
          <i style="cursor:pointer" class="ionicon ion-upload h5" title="upload document"></i>&nbsp;&nbsp;
          <b style="display:inlne-block;position:relative;top:-2px">{{dm.fullMatrix?.files?.length || ''}}</b>
        </button>
      </div>
      <ng-template #uploadRef class="fpm-files">
        <div class="p-4">
          <!-- <button class="nrk-button" (click)="uploadRef.">&nbsp;X&nbsp;</button> -->
          <ngx-form-upload *ngIf="dm.fullMatrix?.files" class="file-upload-comp" url="/api/v1/upload" accept="application/pdf"
            [(files)]="dm.fullMatrix.files" [fullwidth]="true" [hideComment]="false" [hideCheckbox]="true" (completed)="onPriceFileUpload($event, dm.fullMatrix.finishedProduct, dm.fullMatrix.accounting)">
          </ngx-form-upload>  
        </div>
      </ng-template>
    </td></tr>

    <tr><td>
      <ul class="info">
        <li>
          <table class="calctable">
            <tr><th>Quantity & Units</th><th>Value</th><th>Unit</th></tr>
            <tr>
              <td>Quantity in Unit</td>
              <td>
                <ngx-doc-form-texfield class="fullwidth right" [(value)]="$any(dm).calcValues.quantity" (keyupChange)="$any(dm).calcValues.quantity = $event; dm.calc()" [focused]="true" [disabled]="disabled"></ngx-doc-form-texfield>
              </td>
              <td>
                <ngx-doc-form-dropdown *ngIf="dm.isEnergy" [(value)]="dm.calcValues.quantityUnit" [options]="unitOptions" (valueChange)="dm.calc()" [disabled]="disabled"></ngx-doc-form-dropdown>
                <div *ngIf="!dm.isEnergy">pc.</div>
              </td>
            </tr>
            <tr>
              <td>Price in {{compilation.currency}}</td>
              <td>
                <ngx-doc-form-texfield class="fullwidth right" [(value)]="$any(dm).calcValues.price" (keyupChange)="$any(dm).calcValues.price = $event; dm.calc()" [disabled]="disabled"></ngx-doc-form-texfield>
              </td>
              <td>
                <ngx-doc-form-dropdown *ngIf="dm.isEnergy" [(value)]="dm.calcValues.priceUnit" [options]="unitOptions" (valueChange)="dm.calc()" [disabled]="disabled"></ngx-doc-form-dropdown>
                <div *ngIf="!dm.isEnergy">pc.</div>
              </td>
            </tr>
            <tr>
              <td>Price date</td>
              <td>
                <ngx-doc-form-date [(value)]="$any(dm).calcValues.priceDate" [disabled]="disabled" (valueChange)="dm.setPrice()"></ngx-doc-form-date>
              </td>
              <td></td>
            </tr>
            <tr>
              <td>Pricematrix price</td>
              <td style="text-align: right">
                {{ dm.currentPriceMatrix?.value || 'n/a' }} {{ dm.currentPriceMatrix?.currency }}
              </td>
              <td>
                {{ unitData.get(+dm.currentPriceMatrix?.type)?.short || 'n/a' }}
              </td>
            </tr>
            <tr>
              <td>Pricematrix valid from</td>
              <td style="text-align: right">
                {{ dm.currentPriceMatrix?.validFrom ? (dm.currentPriceMatrix?.validFrom | date : 'yyyy-MM-dd') : 'n/a' }}
              </td>
            </tr>
            <tr>
              <td>Pricematrix valid to</td>
              <td style="text-align: right">
                {{ dm.currentPriceMatrix?.validTo ? (dm.currentPriceMatrix?.validTo | date : 'yyyy-MM-dd') : 'n/a' }}
              </td>
            </tr>
          </table>
          <div class="turnover">Turnover in {{compilation.currency}}:&nbsp;&nbsp;&nbsp;{{dm.calcValues.turnover | currency : compilation.currency : 'symbol' : '1.2-2' : 'de'}}</div>
        </li>

        <li *ngIf="dm.isEnergy">

          <div *ngIf="!disabled && data.visibleMap.prices" class="price-to-matrix">
            <button [nbPopover]="toMatrix" class="nrk-button" (click)="dm.calcValues['date'] = now; dm.calcValues['matrix'] = dm.calcValues.secondUnit; dm.calcValues['business'] = compilation.recipient">Transfer Price to Matrix</button>
            <ng-template #toMatrix>
              <div class="popup">
                <h3>Transfer Price to Matrix</h3>
                <p>Issuer:<br>{{issuerData.get(this.compilation.issuer).name}}</p>
                <p>Product:<br>{{this.lineItem.finishedProduct?.calcCode}}<br>{{this.lineItem.finishedProduct?.calcName}}</p>
                <p>
                  {{docConfig.get('prices').price[docConfig.get('prices').docs.indexOf(compilationTypeData.get(this.compilation.type).code)] === 'PP' ? 'Supplier' : 'Customer'}}
                  <ngx-doc-form-filter-select [(value)]="dm.calcValues['business']" [options]="data.businessOptions" (click)="$event.stopPropagation()"></ngx-doc-form-filter-select>
                </p>
                <p>
                  Price : <ngx-doc-form-date [(value)]="dm.calcValues['date']" (click)="$event.stopPropagation()"></ngx-doc-form-date>
                </p>
                <p>
                  <ng-container *ngTemplateOutlet="secondUnit; context: { disabled: false, name: 'transfer', param: 'matrix' }"></ng-container>
                </p>
                <div class="text-center" style="display:flex;justify-content:center;">
                  <button class="nrk-button text-center mr-2" (click)="transferPrice(this.lineItem, dm.calcValues['business'], dm.calcValues['matrix'], dm.metrics.pricePc, dm.calcValues['date'])">Save</button>
                  <button class="nrk-button text-center" (click)="closeMatrixPopup()">Cancel</button>
                </div>
              </div>
            </ng-template>
          </div>

          <ng-container *ngTemplateOutlet="secondUnit; context: { disabled: disabled, name: 'dm.metrics', param: 'secondUnit' }"></ng-container>
          <ng-template #secondUnit let-disabled="disabled" let-name="name" let-param="param">
            <table class="second-unit">
              <tr><th>2nd unit</th><th>Unit</th><th>Quantity</th><th>Price in {{compilation.currency}}</th></tr>
              <tr>
                <td>
                  <input type="radio" [(ngModel)]="dm.calcValues[param]" [name]="name" [value]="1" [attr.disabled]="disabled ? true : null" /> 
                </td>
                <td>pc</td>
                <td>{{dm.metrics.pc | number:'1.4-4'}}</td>
                <td>{{dm.metrics.pricePc | number:'1.4-4'}}</td>
              </tr>
              <tr>
                <td>
                  <input type="radio" [(ngModel)]="dm.calcValues[param]" [name]="name" [value]="4" [attr.disabled]="disabled ? true : null" /> 
                </td>
                <td>m²</td>
                <td>{{dm.metrics.m2 | number:'1.4-4'}}</td>
                <td>{{dm.metrics.priceM2 | number:'1.4-4'}}</td>
              </tr>
              <tr>
                <td>
                  <input type="radio" [(ngModel)]="dm.calcValues[param]" [name]="name" [value]="2" [attr.disabled]="disabled ? true : null" /> 
                </td>
                <td>lm</td>
                <td>{{dm.metrics.m | number:'1.4-4'}}</td>
                <td>{{dm.metrics.priceM | number:'1.4-4'}}</td>
              </tr>
              <tr>
                <td>
                  <input type="radio" [(ngModel)]="dm.calcValues[param]" [name]="name" [value]="3" [attr.disabled]="disabled ? true : null" /> 
                </td>
                <td>100lm</td>
                <td>{{dm.metrics.m100 | number:'1.4-4'}}</td>
                <td>{{dm.metrics.priceM100 | number:'1.4-4'}}</td>
              </tr>
              <tr>
                <td>
                  <input type="radio" [(ngModel)]="dm.calcValues[param]" [name]="name" [value]="5" [attr.disabled]="disabled ? true : null" /> 
                </td>
                <td>kg</td>
                <td>{{dm.metrics.kg | number:'1.4-4'}}</td>
                <td>{{dm.metrics.priceKg | number:'1.4-4'}}</td>
              </tr>
            </table>
          </ng-template>
        </li>

        <!-- <li style="padding-left:3em">
        </li> -->
      </ul>

    </td></tr>

    <tr><td colspan="100" class="text-center">

      <div class="text-center d-inline-block"><button *ngIf="!disabled" class="btn btn-success btn-sm" (click)="save();">Ok</button></div>
      <!-- <div class="text-center"><button *ngIf="!disabled" class="btn btn-primary btn-sm" (click)="dm.setPrice(true)">Update<br>price</button></div> -->
      <div class="text-center d-inline-block"><button class="btn btn-danger btn-sm" (keydown.enter)="$event.preventDefault();close.emit()" (click)="close.emit()">Close</button></div>

    </td></tr>

  </table>

</div>

